// Change #100463 - Billing > Subscriptions (/settings/4/9).
//
// Paul: the same screen as Back End > Company Details > Subscriptions, read
// only. One Subscriptions card: the Enterprise plan row (users included, in
// use, agreed price; never the tolerance) then one row per product, price,
// period and card (bolt-ons such as SIMs included). Below it, the devices
// linked to the company (SIMs, Guest WiFi sites). Changes are made by CRMit;
// who holds each licence is on the Users screen.

import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";

import SettingsPanel from "../../components/SettingsPanel";
import InfoCard from "../../../../Components/Common/InfoCard/InfoCard";
import HandleDateTime from "../../../../Components/Common/HandleDateTime";
import CompanySubscriptions from "../../../BackEnd/CompanyDetails/subscriptions";
import { subscriptionLicenceBoltonsApi } from "../../../../helpers/fakebackend_helper";

const BOLTON_ICON = { SIM: "ri-sim-card-2-line", GUEST_WIFI: "ri-wifi-line" };
const BOLTON_LABEL = { SIM: "SIM", GUEST_WIFI: "Guest WiFi" };

export default function Subscriptions() {
  const [boltons, setBoltons] = useState([]);

  useEffect(() => {
    subscriptionLicenceBoltonsApi()
      .then((x) => setBoltons(x?.status === 200 ? x.bolton_list || [] : []))
      .catch(() => setBoltons([]));
  }, []);

  return (
    <SettingsPanel title="Subscriptions" description="Your plan and the subscriptions you pay for">
      <CompanySubscriptions readOnly />

      {boltons.length > 0 && (
        <div className="mt-3">
          <InfoCard title="Devices & bolt-ons" icon="ri-sim-card-2-line" accent="indigo">
            <div className="text-muted fs-13 mb-2">SIMs and Guest WiFi sites linked to your company.</div>
            <div className="table-responsive">
              <Table className="align-middle table-nowrap mb-0">
                <thead className="text-muted">
                  <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Since</th>
                  </tr>
                </thead>
                <tbody>
                  {boltons.map((b) => (
                    <tr key={`${b.Type}-${b.Id}`}>
                      <td>
                        <i className={`${BOLTON_ICON[b.Type] || "ri-plug-line"} me-1 text-primary`}></i>
                        {BOLTON_LABEL[b.Type] || b.Type}
                      </td>
                      <td className="fw-semibold">{b.Name}</td>
                      <td className="text-muted">{b.Detail || "-"}</td>
                      <td>{b.Status || "-"}</td>
                      <td>{b.Since ? HandleDateTime(b.Since) : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </InfoCard>
        </div>
      )}
    </SettingsPanel>
  );
}
